import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FormMode } from '../../common/form-mode';
import { WorkflowDataInterface } from '../workflow-data.interface';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { TimerStopActionData } from 'src/app/components/designer/models/timer-stop-action-data';
import { Trigger } from 'src/app/components/designer/models/trigger';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { NeedTimerTriggers } from '../need-timer-triggers';

@Component({
    selector: 'app-workflow-action-timer-stop',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, FaIconComponent, MatTooltipModule, MatCheckboxModule],
    templateUrl: './workflow-action-timer-stop.component.html',
    styleUrl: './workflow-action-timer-stop.component.scss'
})
export class WorkflowActionTimerStopComponent implements WorkflowDataInterface, OnInit, NeedTimerTriggers {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: TimerStopActionData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string | TimerStopActionData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as TimerStopActionData;
        }

        this.fillForm();
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): TimerStopActionData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Liste des triggers de type 'Timer' du workflow.
     */
    public _timerTriggers: Trigger[];

    /**
     * Spécifie la liste des triggers de type 'Timer' du workflow.
     */
    set timerTriggers(value: Trigger[]) {
        this._timerTriggers = value;
        this.fillForm();
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            WorkflowTriggerName: new UntypedFormControl('', Validators.required),
        });

        if (this.mode === FormMode.Reading) {
            this.dataForm.disable();
        } else {
            this.dataForm.enable();
        }

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                if (this._timerTriggers) {
                    this.dataForm.get('WorkflowTriggerName').setValue(this._data.workflowTriggerId);
                }
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: TimerStopActionData = new TimerStopActionData();
        updatedData.workflowTriggerId = this.dataForm.get('WorkflowTriggerName').value;

        this._data = updatedData;
    }
}
